import React from "react";
import OrderDetail from "../order/OrderDetail";

const ReturnDetail = () => {
  return <OrderDetail type="return" />;
};

export default ReturnDetail;
